const sectionArray = [
  "filmAndPhotography",
  "wfhEssentialsAndOthers",
  "construction",
  "partyAndEvents",
  "furniture",
  "appliances",
  "electronics",
  "sportsAndFitness",
  "clothingAndAccessories",
  "kidsAndBabies",
  "outDoor",
  "vehicles",
];

const categoryArray = [
  {
    filmAndPhotography: [
      "Camera",
      "Lens",
      "Video Equipments",
      "GoPro & Mount",
      "Youtube & Vlogging",
      "Travel gears",
      "Film and Cinema Equipments",
      "Wild life photography Gears",
    ],
    wfhEssentialsAndOthers: [
      "Wfh Chairs",
      "WFh tables",
      "Wfh Accessories",
      "Hobbies",
      "Other Equipments",
    ],
    construction: [
      "Basic Construction Equipments",
      "Lifting & Handling Equipments",
      "Mining Equipments",
      "Plants",
      "Power Source",
      "Road Equipments",
      "Trucks & Trailors",
    ],
    partyAndEvents: [
      "Wedding Equipments",
      "Party Furniture",
      "Interior Decorations",
      "Tents",
      "Cooking & Serving",
      "Crockery & tableware",
      "Event Management Accessories",
    ],
    furniture: [
      "BedRoom",
      "LivingRoom",
      "Kids Room",
      "Dining Room",
      "Office Essentials",
      "Storage",
    ],
    appliances: [
      "Television",
      "Refrigeration",
      "Washing & Drying",
      "Cooking Essentials",
      "Heating and Cooling",
      "Office Equipments",
    ],
    electronics: [
      "Smart Devices",
      "Personal Computing",
      "Smartphones & Tablets",
      "Recreation Equipments",
    ],
    sportsAndFitness: [
      "Treadmills",
      "Cross Trainers",
      "Exercise Bikes",
      "Massagers",
      "Sport Bikes",
      "Gears",
    ],
    clothingAndAccessories: [
      "Mens Wear",
      "Womens Wear",
      "Wedding Attire",
      "Adornments",
      "Accessories",
      "Covid-19 Hospital supplies",
    ],
    kidsAndBabies: [
      "Bouncers & Swings",
      "Baby Car Seats",
      "Highchairs and Playpens",
      "Strollers ",
      "Kids Inflatables",
      "Kids Bikes",
      "Kids Costumes",
    ],
    outDoor: [
      "Backpacks",
      "Camp mattresses & Cots",
      "Camping lights",
      "Sleeping bags",
      "Camping Tents",
      "Accessories & Others",
    ],
    vehicles: [
      "Electric Bikes",
      "Cars",
      "Promotional Vehicles",
      "Campaign Van",
      "Buses & Vans",
    ],
  },
];

// const categoryArray = [
//   { filmAndPhotography: ["hello", "baby"] },
//   { wfhEssentialsAndOthers: "sdcdsc" },
//   { construction: ["state.section"] },
//   { partyAndEvents: [] },
//   { furniture: [] },
//   { appliances: [] },
//   { electronics: [] },
//   { sportsAndFitness: [] },
//   { clothingAndAccessories: [] },
//   { kidsAndBabies: ["kids", "hello", "baby"] },
//   { outDoor: [] },
//   { vehicles: [] },
// ];

export { sectionArray, categoryArray };
